module.exports = __webpack_public_path__ + "static/media/bf.8471d39b.svg";